import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const coreSlide = createSlice({
    name: "core",
    initialState: {
        sidebarShow: true,
        commonData: null,
        urlParam: null,
        loginEmail: null,
        tableToken: null,
        tableTokenExpire: null,

        loginCheckEmailSuccess: false,
        loginCheckEmailFail: false,
        loginCheckEmailErrorMessage: null,
        loginCheckEmailResponseData: null,

        sendOTPCodeSuccess: false,
        sendOTPCodeFail: false,
        sendOTPCodeErrorDetail: null,

        verifyOTPCodeSuccess: false,
        verifyOTPCodeFail: false,
        verifyOTPCodeErrorDetail: null,

        registerSuccess: false,
        registerFail: false,
        registerErrorMessage: null,
        registerResponseData: null,

        tableDetailSuccess: false,
        tableDetailFail: false,
        tableDetailErrorMessage: null,
        tableDetailResponseData: null,

        loggedIn: null,
        loginResponseData: null,
        loginFailedDetail: null,
        loginSuccess: false,
        logoutSuccess: false,
        logoutFail: false,
    },
    reducers: {
        setSideBarShow: (state, action) => {
            state.sidebarShow = action.payload;
        },
        setUrlParam: (state, action) => {
            state.urlParam = action.payload;
        },
        setLoginEmail: (state, action) => {
            state.loginEmail = action.payload;
        },
        setTableToken: (state, action) => {
            state.tableToken = action.payload;
        },
        setTableTokenExpire: (state, action) => {
            state.tableTokenExpire = action.payload;
        },
        setCommonData: (state, action) => {
            state.commonData = action.payload.meta;
        },
        doLoginCheckEmailSuccess: (state, action) => {
            state.loginCheckEmailSuccess = true;
            state.loginCheckEmailFail = false;
            state.loginCheckEmailErrorMessage = null;
            state.loginCheckEmailResponseData = action.payload.data;
        },
        doLoginCheckEmailFail: (state, action) => {
            state.loginCheckEmailSuccess = false;
            state.loginCheckEmailFail = true;
            state.loginCheckEmailErrorMessage = action.payload.data;
        },
        doLoginVerifyCodeSuccess: (state, action) => {
            state.loginResponseData = action.payload.data;
            state.loginSuccess = true;
            state.logoutSuccess = false;
            state.loginFailedDetail = null;
        },
        doLoginVerifyCodeFail: (state, action) => {
            state.loggedIn = null;
            state.loginSuccess = false;
            state.loginFailedDetail = action.payload.data;
        },
        resetLoginFailState: (state, action) => {
            state.loggedIn = null;
            state.loginResponseData = null;
            state.loginSuccess = false;
            state.loginFailedDetail = null;
        },
        doRegisterSuccess: (state, action) => {
            state.registerSuccess = true;
            state.registerFail = false;
            state.registerErrorMessage = null;
            state.registerResponseData = action.payload.data;
        },
        doRegisterFail: (state, action) => {
            state.registerSuccess = false;
            state.registerFail = true;
            state.registerErrorMessage = action.payload.data;
        },
        resetRegisterState: (state, action) => {
            state.loginCheckEmailSuccess = action.payload;
            state.loginCheckEmailFail = action.payload;
            state.loginCheckEmailResponseData = null;
            state.loginCheckEmailErrorMessage = null;
            state.registerSuccess = action.payload;
            state.registerFail = action.payload;
            state.registerResponseData = null;
            state.registerErrorMessage = null;
        },
        doGetTableDetailSuccess: (state, action) => {
            state.tableDetailSuccess = true;
            state.tableDetailFail = false;
            state.tableDetailErrorMessage = null;
            state.tableDetailResponseData = action.payload.data;
        },
        doGetTableDetailFail: (state, action) => {
            state.tableDetailSuccess = false;
            state.tableDetailFail = true;
            state.tableDetailErrorMessage = action.payload.data;
        },
        resetTableState: (state, action) => {
            state.tableDetailSuccess = action.payload;
            state.tableDetailFail = action.payload;
            state.tableDetailResponseData = null;
            state.tableDetailErrorMessage = null;
        },
        doLoggedInSuccess: (state, action) => {
            state.loggedIn = action.payload;
        },
        doLoggedInFail: (state, action) => {
            state.loggedIn = null;
        },
        doLogoutSuccess: (state, action) => {
            state.loggedIn = null;
            state.loginSuccess = false;
            state.logoutSuccess = true;
            state.logoutFail = false;
        },
        doLogoutFail: (state, action) => {
            state.logoutSuccess = false;
            state.logoutFail = true;
        },
        resetLogoutState: (state, action) => {
            state.logoutSuccess = false;
            state.logoutFail = false;
        },
        doSendOTPCodeSuccess: (state, action) => {
            state.sendOTPCodeSuccess = true;
            state.sendOTPCodeFail = false;
            state.sendOTPCodeErrorDetail = null;
        },
        doSendOTPCodeFail: (state, action) => {
            state.sendOTPCodeSuccess = false;
            state.sendOTPCodeFail = true;
            state.sendOTPCodeErrorDetail = action.payload.data;
        },
        resetSendOTPCodeState: (state, action) => {
            state.sendOTPCodeSuccess = false;
            state.sendOTPCodeFail = false;
            state.sendOTPCodeErrorDetail = null;
        },
        doVerifyOTPCodeSuccess: (state, action) => {
            state.verifyOTPCodeSuccess = true;
            state.verifyOTPCodeFail = false;
            state.verifyOTPCodeErrorDetail = null;
        },
        doVerifyOTPCodeFail: (state, action) => {
            state.verifyOTPCodeSuccess = false;
            state.verifyOTPCodeFail = true;
            state.verifyOTPCodeErrorDetail = action.payload.data;
        },
        resetVerifyOTPCodeState: (state, action) => {
            state.verifyOTPCodeSuccess = false;
            state.verifyOTPCodeFail = false;
            state.verifyOTPCodeErrorDetail = null;
        },
    },
});

export const doLoginVerifyCode = (param) => async (dispatch) => {
    try {
        const url = `/api/customer/auth/login/verify-code`;
        const response = await axios.post(url, param);
        dispatch(doLoginVerifyCodeSuccess(response.data));
    } catch (error) {
        dispatch(doLoginVerifyCodeFail(error.response));
    }
};

export const doRegister = (param) => async (dispatch) => {
    try {
        let data = param;

        const url = `/api/customer/auth/register`;
        const response = await axios.post(url, data);

        dispatch(doRegisterSuccess(response.data));
    } catch (error) {
        dispatch(doRegisterFail(error.response));
    }
};

export const doGetCommonData = () => async (dispatch) => {
    try {
        const response = await axios.get("/api/investor/commons/meta");
        dispatch(setCommonData({ meta: response.data }));
    } catch (error) {
        dispatch(setCommonData({ meta: null }));
    }
};

export const doLoginCheckEmail = (param) => async (dispatch) => {
    try {
        let data = param;
    
        const url = `/api/customer/auth/login/check`;
        const response = await axios.post(url, data);

        dispatch(doLoginCheckEmailSuccess(response.data));
    } catch (error) {
        dispatch(doLoginCheckEmailFail(error.response));
    }
};

export const doResetRegisterState = () => async (dispatch) => {
    dispatch(resetRegisterState(false));
};

export const doResetLoginFailState  = () => async (dispatch) => {
    dispatch(resetLoginFailState());
};

export const doResetTableState  = () => async (dispatch) => {
    dispatch(resetTableState());
};

export const doGetTableDetail = (param) => async (dispatch) => {
    try {
        const url = `/api/customer/auth/table`;
        const response = await axios.post(url, param);

        dispatch(doGetTableDetailSuccess(response.data));
    } catch (error) {
        dispatch(doGetTableDetailFail(error.response));
    }
}

export const doGetLoggedInUserDetails = () => async (dispatch) => {
	try {
        const url = `/api/customer/auth/me`;
        const response = await axios.get(url);
        dispatch(doLoggedInSuccess(response.data));
    } catch (error) {
        dispatch(doLoggedInFail(error.response));
    }
};

export const doLogout = () => async (dispatch) => {
    try {
        const url = `/api/admin/auth/logout`;
        const response = await axios.get(url);
        dispatch(doLogoutSuccess(response.data));
    } catch (error) {
        dispatch(doLogoutFail(error.response));
    }
};

export const doSetUrlParam = (param) => async (dispatch) => {
   dispatch(setUrlParam(param));
};

export const updateSidebarShow = (param) => async (dispatch) => {
    dispatch(setSideBarShow(param));
 };

export const doSetLoginEmail = (param) => async (dispatch) => {
    dispatch(setLoginEmail(param));
};

export const doSetTableToken = (param) => async (dispatch) => {
    dispatch(setTableToken(param));
};

export const doSetTableTokenExpire = (param) => async (dispatch) => {
    dispatch(setTableTokenExpire(param));
};

export const doResetLogoutState = () => async (dispatch) => {
    dispatch(resetLogoutState());
};

export const doSendOTPCode = (param) => async (dispatch) => {
	try {
        const url = `/api/customer/auth/register/otp/send`;
        const response = await axios.post(url, param);

        dispatch(doSendOTPCodeSuccess(response.data));
    } catch (error) {
        dispatch(doSendOTPCodeFail(error.response));
    }
};

export const doResetSendOTPCodeState = () => async (dispatch) => {
    dispatch(resetSendOTPCodeState());
};

export const doVerifyOTPCode = (param) => async (dispatch) => {
	try {
        const url = `/api/customer/auth/register/otp/verify`;
        const response = await axios.post(url, param);

        dispatch(doVerifyOTPCodeSuccess(response.data));
    } catch (error) {
        dispatch(doVerifyOTPCodeFail(error.response));
    }
};

export const doResetVerifyOTPCodeState = () => async (dispatch) => {
    dispatch(resetVerifyOTPCodeState());
};

export const { 
    setSideBarShow,
    setCommonData,
    doLoginCheckEmailSuccess,
    doLoginCheckEmailFail,
    doRegisterSuccess,
    doRegisterFail,
    doLoginVerifyCodeSuccess,
    resetRegisterState,
    resetLoginFailState,
    doGetTableDetailSuccess,
    doGetTableDetailFail,
    resetTableState,
    setUrlParam,
    setLoginEmail,
    setTableToken,
    setTableTokenExpire,
    doLoginVerifyCodeFail,
    doLoggedInSuccess, 
    doLoggedInFail, 
    resetLoginFail,
    doLogoutSuccess,
    doLogoutFail,
    resetLogoutState,
    doSendOTPCodeSuccess,
    doSendOTPCodeFail,
    resetSendOTPCodeState,
    doVerifyOTPCodeSuccess,
    doVerifyOTPCodeFail,
    resetVerifyOTPCodeState,
} = coreSlide.actions;

export const getSideBarShow = (state) => state.core?.sidebarShow;
export const getCommonData = (state) => state.core?.commonData;

export const getLoginCheckEmailSuccess = (state) => state.core?.loginCheckEmailSuccess;
export const getLoginCheckEmailFail = (state) => state.core?.loginCheckEmailFail;
export const getLoginCheckEmailErrorMessage = (state) => state.core?.loginCheckEmailErrorMessage;
export const getLoginCheckEmailResponseData = (state) => state.core?.loginCheckEmailResponseData;

export const getRegisterSuccess = (state) => state.core?.registerSuccess;
export const getRegisterFail = (state) => state.core?.registerFail;
export const getRegisterErrorMessage = (state) => state.core?.registerErrorMessage;
export const getRegisterResponseData = (state) => state.core?.registerResponseData;

export const getTableDetailSuccess = (state) => state.core?.tableDetailSuccess;
export const getTableDetailFail = (state) => state.core?.tableDetailFail;
export const getTableDetailErrorMessage = (state) => state.core?.tableDetailErrorMessage;
export const getTableDetailResponseData = (state) => state.core?.tableDetailResponseData;

export const getLoginFailedDetail = (state) => state.core?.loginFailedDetail;
export const getLoginResponseData = (state) => state.core?.loginResponseData;
export const getLoginSuccess = (state) => state.core?.loginSuccess;
export const getLoggedIn = (state) => state.core?.loggedIn;
export const getLogoutSuccess = (state) => state.core?.logoutSuccess;
export const getUrlParam = (state) => state.core?.urlParam;
export const getLoginEmail = (state) => state.core?.loginEmail;
export const getTableToken = (state) => state.core?.tableToken;
export const getTableTokenExpire = (state) => state.core?.tableTokenExpire;

export const getSendOtpCodeSuccess = (state) => state.core?.sendOTPCodeSuccess;
export const getSendOtpCodeFail = (state) => state.core?.sendOTPCodeFail;
export const getSendOtpCodeErrorDetail = (state) => state.core?.sendOTPCodeErrorDetail;

export const getVerifyOtpCodeSuccess = (state) => state.core?.verifyOTPCodeSuccess;
export const getVerifyOtpCodeFail = (state) => state.core?.verifyOTPCodeFail;
export const getVerifyOtpCodeErrorDetail = (state) => state.core?.verifyOTPCodeErrorDetail;

export default coreSlide.reducer;
